import { render, staticRenderFns } from "./DigitalForm.vue?vue&type=template&id=5d7721f1&"
import script from "./DigitalForm.vue?vue&type=script&lang=ts&"
export * from "./DigitalForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports